import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import { HTTP } from "../api/http-common";
import Swal from "sweetalert2";
import { Eye, EyeOff } from "lucide-react";
import { MultiSelect } from "react-multi-select-component";
import { isValidEmail } from "./common";
import { useGlobalContext } from "./../component/GlobalContext";
import { loadStripe } from '@stripe/stripe-js';
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHED_KEY);


function MembersMembershipModal({ showModal, setShowModal, formData, setFormData }) {
  const { globalUserVar, isAuthenticated, setIsAuthenticated, isActiveMember } = useGlobalContext();
  const [emailError, setEmailError] = useState("");
  const [firstNameError, setFirstNameError] = useState("");
  const [lastNameError, setLastNameError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [passwordShow, setPasswordShow] = useState(false);
  const [cpasswordShow, setcPasswordShow] = useState(false);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const styles = {
    modal: {
      content: {
        padding: '30px',
        borderRadius: '10px',
        backgroundColor: '#fff',
        maxWidth: '600px',
        margin: 'auto',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        position: 'absolute',
        maxHeight: '600px',
      },
    },
  }
  const hideShowPass = () => {
    setPasswordShow(!passwordShow);
  }
  const hideShowcPass = () => {
    setcPasswordShow(!cpasswordShow);
  }
  const resetValidationErrors = () => {
    setFirstNameError('')
    setLastNameError('')
    setEmailError('')
    setPasswordError('')
  }
  const validateField = () => {
    resetValidationErrors();

    let checked = true;

    if (formData.email === '') {
      setEmailError('Please enter email address');
      if (checked) {
        checked = false;
      }
    }
    else if (!isValidEmail(formData.email)) {
      setEmailError('Invalid email.');
      if (checked) {
        checked = false;
      }
    } else if (formData.email.length > 100) {
      setEmailError("Max character limit is 100");
      if (checked) {
        checked = false;
      }
    }

    if (formData.first_name === '') {
        setFirstNameError('Please enter first Name');
        if (checked) {
            checked = false;
        }
    } else if (formData.first_name.length < 3) {
        setFirstNameError("Please enter minimum 3 characters");
        if (checked) {
            checked = false;
        }
    } else if (formData.first_name.length > 100) {
        setFirstNameError("Max character limit is 100");
        if (checked) {
            checked = false;
        }
    }

    if (formData.last_name === '') {
        setLastNameError('Please enter last Name');
        if (checked) {
            checked = false;
        }
    } else if (formData.last_name.length < 3) {
        setLastNameError("Please enter minimum 3 characters");
        if (checked) {
            checked = false;
        }
    } else if (formData.last_name.length > 100) {
        setLastNameError("Max character limit is 100");
        if (checked) {
            checked = false;
        }
    }

    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#&?])[A-Za-z\d!@#&?]{8,64}$/;
        
    // console.log(passwordRegex.test(formData.password))
        let errorMessage = '';
        if (formData.password === '') {
            setPasswordError('Please enter password');
            if (checked) {
                checked = false;
            }
        }

        if (formData.password.length < 5) {
          setPasswordError("Please enter minimum 5 characters");
          if (checked) {
              checked = false;
          }
        } 

        if (formData.confirm_password === '') {
            setPasswordError('Please enter confirm password');
            if (checked) {
                checked = false;
            }
        }
        if (formData.password !== formData.confirm_password) {
            setPasswordError('Please confirm password');
            if (checked) {
                checked = false;
            }
        }

    return checked;
  };

  const handleVerification = async (event) => {
    event.preventDefault();

    if (validateField()) {
      try {
        // Optional: if using token-based auth, uncomment and set token
        // const access_token = localStorage.getItem("access_token");
        let config = {
          // headers: { "Content-Type": "application/json", token: access_token },
        };

        const response = await HTTP.post("/stripe/isregistered/member", formData, config);

        console.log(response.data.content)

        if (response.status === 200) {
          localStorage.setItem('payment_session_id',response.data.content);
          const stripe = await stripePromise;
          await stripe.redirectToCheckout({ sessionId: response.data.content });

          // // Optionally:
          setShowModal(false);
        }
      } catch (error) {
        console.log(error)
        if (error.response && error.response.status === 406) {
          Swal.fire({
            title: 'Error!',
            text: error.response.data.detail,
            confirmButtonText: 'Ok'
          });
        } else {
          Swal.fire("Error", "There was an unexpected error.", "error");
        }
      }
    }
  };
  return (
    <>
      <Modal
        isOpen={showModal}
        onRequestClose={() => setShowModal(false)}
        contentLabel="Add"
        style={styles.modal}
      >
        <div className="flex flex-col space-y-1.5 text-center sm:text-left">
          <h2 className="text-lg sm:text-xl font-semibold leading-none tracking-tight">
            Confirm your details and pay
          </h2>
          <p className="text-sm text-muted-foreground">&nbsp;</p>
        </div>

        <form
          className="space-y-6 custom-overlay-position mt-4"
          onSubmit={handleVerification}
        >
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {/* First Name Input */}
            <div className="space-y-2 col-span-2">
              <label
                htmlFor="email"
                className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
              >
                First Name:
              </label>
              <div className="relative space-y-1">
                <input
                  className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400 placeholder:text-gray-400"
                  placeholder="First Name"
                  name="first_name"
                  id="first_name"
                  aria-describedby="email-description"
                  aria-invalid="false"
                  value={formData.first_name}
                  onChange={handleChange}
                />
                {firstNameError && (
                  <span className="text-sm text-red-500">{firstNameError}</span>
                )}
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {/* Last Name Input */}
            <div className="space-y-2 col-span-2">
              <label
                htmlFor="email"
                className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
              >
                Last Name:
              </label>
              <div className="relative space-y-1">
                <input
                  className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400 placeholder:text-gray-400"
                  placeholder="Last Name"
                  name="last_name"
                  id="last_name"
                  aria-describedby="email-description"
                  aria-invalid="false"
                  value={formData.last_name}
                  onChange={handleChange}
                />
                {lastNameError && (
                  <span className="text-sm text-red-500">{lastNameError}</span>
                )}
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {/* Email Input */}
            <div className="space-y-2 col-span-2">
              <label
                htmlFor="email"
                className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
              >
                Registered Email:
              </label>
              <div className="relative space-y-1">
                <input
                  className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400 placeholder:text-gray-400"
                  type="email"
                  placeholder=""
                  name="email"
                  id="email"
                  aria-describedby="email-description"
                  aria-invalid="false"
                  value={formData.email}
                  onChange={handleChange}
                />
                {emailError && (
                  <span className="text-sm text-red-500">{emailError}</span>
                )}
              </div>
            </div>
          </div>
          {!isAuthenticated ? (
            <>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {/* Password Input */}
                <div className="space-y-2 col-span-2">
                  <label
                    htmlFor="email"
                    className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                  >
                    Password:
                  </label>
                  <div className="relative space-y-1">
                    <input
                      className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400 placeholder:text-gray-400"
                      type={passwordShow ? "text" : "password"}
                      placeholder=""
                      name="password"
                      id="password"
                      aria-describedby="email-description"
                      aria-invalid="false"
                      value={formData.password}
                      onChange={handleChange}
                    />
                    <button
                        type="button"
                        className="absolute right-0 bottom-2 text-gray-400"
                        onClick={hideShowPass}
                        >
                            {passwordShow ?  <Eye className="mr-2 h-4 w-4" /> :  <EyeOff className="mr-2 h-4 w-4" />}
                        </button>
                    {passwordError && (
                      <span className="text-sm text-red-500">{passwordError}</span>
                    )}
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {/* Confirm Password Input */}
                <div className="space-y-2 col-span-2">
                  <label
                    htmlFor="email"
                    className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                  >
                    Confirm Password:
                  </label>
                  <div className="relative space-y-1">
                    <input
                      className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400 placeholder:text-gray-400"
                      type={cpasswordShow ? "text" : "password"}
                      placeholder=""
                      name="confirm_password"
                      id="confirm_password"
                      aria-describedby="email-description"
                      aria-invalid="false"
                      value={formData.confirm_password}
                      onChange={handleChange}
                    />
                    <button
                        type="button"
                        className="absolute right-0 bottom-2 text-gray-400"
                        onClick={hideShowcPass}
                        >
                            {cpasswordShow ? <Eye className="mr-2 h-4 w-4" /> : <EyeOff className="mr-2 h-4 w-4" /> }
                        </button>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>&nbsp;</>
          )}
          

          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
            <button
              className="inline-flex items-center justify-center gap-2 text-sm font-medium transition-colors focus:outline-none focus:ring-1 focus:ring-ring disabled:pointer-events-none disabled:opacity-50 shadow px-4 py-2 w-full sm:w-auto bg-[#6C38FF] hover:bg-[#5b2ee6] text-white rounded-lg respomsive-button-size"
              type="submit"
            >
              Confirm & Pay ${formData.plan_amount} for {formData.plan_type}
            </button>

            <button
              className="inline-flex items-center justify-center gap-2 text-sm font-medium transition-colors focus:outline-none focus:ring-1 focus:ring-ring disabled:pointer-events-none disabled:opacity-50 shadow px-4 py-2 w-full sm:w-auto bg-[#6C38FF] hover:bg-[#5b2ee6] text-white rounded-lg respomsive-button-size"
              type="button"
              onClick={() => setShowModal(false)}
            >
              Close
            </button>
          </div>
        </form>
      </Modal>

    </>
  )
}

export default MembersMembershipModal